var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import withDesign from '../../../hocs/withDesign';
import { ContentContainer } from '../../templates/ContentContainer';
import { BaseInput } from '../BaseInput';
import { GenericComponent } from '../GenericComponent';
import { TranslatedText } from '../TranslatedText';
export var RadioInputComponent = forwardRef(function (_a, ref) {
    var components = _a.components, label = _a.label, id = _a.id, name = _a.name, schema = _a.schema, content = _a.content, checked = _a.checked, onChange = _a.onChange, onBlur = _a.onBlur, defaultChecked = _a.defaultChecked, required = _a.required, value = _a.value;
    var mergedId = id !== null && id !== void 0 ? id : name;
    return (_jsxs(GenericComponent, __assign({ schema: schema }, { children: [_jsx(BaseInput, { design: components.input, ref: ref, id: mergedId, name: name, type: "radio", checked: checked, onChange: onChange, defaultChecked: defaultChecked, required: required, value: value, onBlur: onBlur }), (components.label || label) && (_jsx(TranslatedText, __assign({}, label, { element: "label", htmlFor: mergedId, design: components.label, active: checked }))), (components.content || content) && (_jsx(ContentContainer, { as: "label", htmlFor: mergedId, design: components.content || components.label, active: checked, content: content }))] })));
});
export var RadioInput = withDesign(RadioInputComponent);
RadioInput.displayName = 'RadioInput';
export * from './RadioInput.types';
